var GAME_CONTROLLER_TYPES = {
    HISTORY: 'history',
    HELP: 'help',
    SETTINGS: 'settings',
    FULL_SCREEN: 'fullscreen',
    FULL_SCREEN_OUT: 'fullscreen-out',
    SOUND: 'sound',
    MUTE: 'mute',
    PAYOUTS_AND_LIMITS: 'limits',
    RESULTS: 'results',
    STATISTICS: 'statistics',
};

export { GAME_CONTROLLER_TYPES };
